import { T } from "@/locales";

export default [
  {
    title: T("序号"),
    dataIndex: "index",
    fixed: "left",
    width: 60,
    customRender: (value, item, index) => index + 1,
  },
  {
    title: T("货品名称"),
    dataIndex: "material_name",
    width: 240,
    fixed: "left",
    ellipsis: true,
  },
  {
    title: T("库位编号"),
    dataIndex: "location_number",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("仓库"),
    dataIndex: "warehouse_name",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("货品编号"),
    dataIndex: "material_number",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("批次编号"),
    dataIndex: "batch_number",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("流水类型"),
    dataIndex: "type_display",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("创建时间"),
    dataIndex: "create_time",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("操作前数量"),
    dataIndex: "quantity_before",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("操作数量"),
    dataIndex: "quantity_change",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("现有库存量"),
    dataIndex: "quantity_after",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("单据编号"),
    dataIndex: "order_number",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("往来单位单号"),
    dataIndex: "external_number",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("创建人"),
    dataIndex: "creator_name",
    width: 120,
    ellipsis: true,
  },
];
